<template>
  <footer class="site-footer">
    <div class="footer-inner">
      <!-- Main footer -->
      <div class="footer-grid">
        <!-- Brand / intro -->
        <div class="footer-brand">
          <img :src="brand.logoFullWhite" alt="Guiders" class="footer-logo" />

          <p class="footer-description">
            {{ $t("footer.description") }}
          </p>

          <div class="footer-socials">
            <a
              href="https://www.facebook.com/guiders.pt"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
            >
              <i class="fab fa-facebook-f" aria-hidden="true"></i>
            </a>

            <a
              href="https://www.instagram.com/guiders.pt/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <i class="fab fa-instagram" aria-hidden="true"></i>
            </a>

            <a
              href="https://www.tiktok.com/@guiders.pt"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="TikTok"
            >
              <i class="fab fa-tiktok" aria-hidden="true"></i>
            </a>

            <a
              href="https://wa.me/351920043375"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="WhatsApp"
            >
              <i class="fab fa-whatsapp" aria-hidden="true"></i>
            </a>
          </div>

          <div class="footer-badges mt-6">
            <a
              class="turismo"
              href="https://www.visitportugal.com/pt-pt/content/guiders"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="../../assets/turismo_portugal.jpeg"
                alt="Turismo de Portugal"
              />
            </a>

            <!-- Trade membership: only on the DMC page (/portugal-dmc, /pt/portugal-dmc...) -->
            <a
              v-if="isDmcPage"
              class="turismo"
              href="https://www.evintra.com/ref/V8M2YZXM"
              target="_blank"
              rel="noopener"
            >
              <img
                src="https://www.evintra.com/images/member/evintra-member.png"
                alt="EVINTRA Member"
                loading="lazy"
              />
            </a>
          </div>
        </div>

        <!-- Company -->
        <div class="footer-column">
          <p class="footer-heading">{{ $t("footer.company") }}</p>

          <a
            href="https://firebasestorage.googleapis.com/v0/b/tours-26f02.appspot.com/o/documents%2FAboutUs.pdf?alt=media"
            target="_blank"
            rel="noopener noreferrer"
          >
            {{ $t("footer.aboutUs") }}
          </a>

          <router-link :to="$lp('/portugal-dmc')" @click.native="scrollTop">
            {{ $t("footer.dmcServices") }}
          </router-link>

          <a
            href="https://guiders.pt/login"
            target="_blank"
            rel="noopener noreferrer"
          >
            {{ $t("footer.supplierLogin") }}
          </a>

          <!-- Private guides: signed-in guides go straight in, others get
               the guide login (router: meta.loginRoute) -->
          <router-link :to="{ name: 'guide-portal' }" @click.native="scrollTop">
            {{ $t("footer.guidePortal") }}
          </router-link>

          <a
            href="https://guiders.promoteboost.com/portal/register"
            target="_blank"
            rel="noopener noreferrer"
          >
            {{ $t("footer.becomeAffiliate") }}
          </a>
        </div>

        <!-- Tours -->
        <div class="footer-column">
          <p class="footer-heading">{{ $t("footer.tours") }}</p>

          <a :href="$lp('/') + '#city-tours'">
            {{ $t("footer.cityTours") }}
          </a>

          <a :href="$lp('/') + '#tuk-tuk'">
            {{ $t("footer.tukTukTours") }}
          </a>

          <router-link :to="{ name: 'quote' }" @click.native="scrollTop">
            {{ $t("footer.customizeTrip") }}
          </router-link>
        </div>

        <!-- Contact -->
        <div class="footer-column">
          <p class="footer-heading">{{ $t("footer.contact") }}</p>

          <a href="mailto:support@guiders.pt"> support@guiders.pt </a>

          <a href="https://wa.me/351920043375"> (+351) 920 043 375 </a>
        </div>

        <!-- Payments -->
        <div class="footer-column footer-payments">
          <p class="footer-heading">{{ $t("footer.paymentMethods") }}</p>

          <div class="payment-icons">
            <img src="../../assets/Visa.png" alt="Visa" />
            <img src="../../assets/Mastercard.png" alt="Mastercard" />
            <img src="../../assets/UnionPay.png" alt="UnionPay" />
            <img src="../../assets/Discover.png" alt="Discover" />
            <img src="../../assets/DinersClub.png" alt="Diners Club" />
            <img src="../../assets/Amex.png" alt="American Express" />
            <img src="../../assets/JCB.png" alt="JCB" />
            <img src="../../assets/Bancontact.png" alt="Bancontact" />
            <img src="../../assets/GooglePay.png" alt="Google Pay" />
            <img src="../../assets/ApplePay.png" alt="Apple Pay" />
            <img src="../../assets/Alipay.png" alt="Alipay" />
            <img src="../../assets/Giropay.png" alt="Giropay" />
            <img src="../../assets/Ideal.png" alt="iDEAL" />
            <img src="../../assets/Klarna.png" alt="Klarna" />
          </div>
        </div>
      </div>

      <!-- Bottom section -->
      <div class="footer-bottom">
        <div class="footer-legal">
          <a
            href="https://firebasestorage.googleapis.com/v0/b/tours-26f02.appspot.com/o/documents%2FContracts.pdf?alt=media&token=adb6898d-d0c6-41bc-be5d-1e49740c99ba"
            target="_blank"
            rel="noopener noreferrer"
          >
            {{ $t("footer.contracts") }}
          </a>

          <span aria-hidden="true">·</span>

          <a
            href="https://firebasestorage.googleapis.com/v0/b/tours-26f02.appspot.com/o/documents%2FPrivacy%20policy.pdf?alt=media&token=e6925517-73ae-4405-bc01-feaeb8e1526d"
            target="_blank"
            rel="noopener noreferrer"
          >
            {{ $t("footer.privacyPolicy") }}
          </a>

         <!--  <a href="https://guiders.pt/frequently-asked-questions">
            Support
          </a> -->
        </div>

        <div class="footer-copyright">© 2026 Guiders · RNAAT: 61/2023</div>
      </div>
    </div>
  </footer>
</template>

<script>
import loadThemeFont from "@/components/home/loadThemeFont";
import { brand } from "@/data/homepage";

export default {
  name: "GuidersFooter",
  data() {
    return { brand };
  },
  computed: {
    isDmcPage() {
      return ["portugal-dmc", "portugal-dmc-lang"].includes(this.$route.name);
    },
  },
  created() {
    // Old-design pages don't load the theme font themselves
    loadThemeFont();
  },
  methods: {
  scrollTop() {
    window.scrollTo({ top: 0 })
  }
}
};
</script>

<style lang="scss" scoped>
// Same look as components/home/SiteFooter.vue (homepage design).
// Self-contained on purpose: this footer is also shown on old-design
// pages that don't load the theme (styles/main.scss).
@import "@/styles/variables";

.site-footer {
  width: 100%;
  margin-top: 5rem; // spacing on old pages; GhPage removes it
  padding: 3rem 1.5rem;
  background: $forest-deep;
  color: $on-dark-sub;
  font-family: $family-primary;
  font-size: 0.875rem;
  line-height: 1.5;
  text-align: left;
}

// Same widths as the Bulma .container used by the header and sections
.footer-inner {
  max-width: 960px;
  margin: 0 auto;

  @media screen and (min-width: 1216px) {
    max-width: 1152px;
  }
  @media screen and (min-width: 1408px) {
    max-width: 1344px;
  }
}

a {
  color: $on-dark-sub;
  text-decoration: underline;
  transition: color 0.2s ease;

  &:hover {
    color: $lime;
  }
}

/* -----------------------------
   Main grid
----------------------------- */

.footer-grid {
  display: grid;
  grid-template-columns: 1.6fr repeat(3, 1fr) 1.3fr;
  gap: 2.5rem;
  padding-bottom: 2.5rem;
}

.footer-logo {
  display: block;
  height: 2rem;
  width: auto;
  margin: 0 0 0.75rem;
}

.footer-description {
  margin: 0 0 1.25rem;
  max-width: 17rem;
  line-height: 1.6;
}

/* -----------------------------
   Columns
----------------------------- */

.footer-column {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.375rem;
}

.footer-heading {
  margin: 0 0 0.5rem;
  font-weight: 700;
  font-size: 0.875rem;
  color: $white;
}

/* -----------------------------
   Socials
----------------------------- */

.footer-socials {
  display: flex;
  align-items: center;
  gap: 0.5rem;

  a {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 2.25rem;
    height: 2.25rem;
    border-radius: $radius-rounded;
    background: $forest-card;
    color: $white;
    text-decoration: none;
    font-size: 1rem;
    transition: background 0.2s ease, color 0.2s ease;

    &:hover {
      background: $lime;
      color: $forest;
    }
  }
}

/* -----------------------------
   Payments
----------------------------- */

.payment-icons {
  display: flex;
  flex-wrap: wrap;
  gap: 0.375rem;
  max-width: 14rem;

  img {
    display: block;
    width: auto;
    height: 22px;
    margin: 0;
    object-fit: contain;
  }
}

/* -----------------------------
   Bottom
----------------------------- */

.footer-bottom {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  gap: 1.5rem;
  padding-top: 1.5rem;
  border-top: 1px solid rgba($white, 0.12);
  font-size: 0.8125rem;
}

.footer-legal {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
}

// Turismo de Portugal (and EVINTRA on the DMC page), side by side
.footer-badges {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
}

// White badge so the logo reads on the dark background
.turismo {
  display: flex;
  justify-content: center;
  padding: 0.375rem 0.625rem;
  background: $white;
  border-radius: $radius;
  width: fit-content;

  img {
    display: block;
    max-width: 100px;
    height: 34px;
    object-fit: contain;
  }
}

.footer-copyright {
  text-align: right;
}

/* -----------------------------
   Responsive
----------------------------- */

@media screen and (max-width: 1023px) {
  .footer-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 2.5rem 2rem;
  }

  .footer-brand {
    grid-column: 1 / -1;
  }
}

@media screen and (max-width: 768px) {
  .site-footer {
    margin-top: 3rem;
  }

  .footer-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 2rem 1.5rem;
  }

  .footer-payments {
    grid-column: 1 / -1;
  }

  .footer-bottom {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }

  .footer-copyright {
    text-align: left;
  }
}
</style>
